import { useEffect, useRef } from 'react';

export default function ParticleBackground() {
  const canvasRef = useRef(null);

  useEffect(() => {
    const canvas = canvasRef.current;
    if (!canvas) return;
    const ctx = canvas.getContext('2d');
    let particles = [];
    let animationFrameId;

    const setCanvasDimensions = () => {
      canvas.width = window.innerWidth;
      canvas.height = window.innerHeight;
    };
    setCanvasDimensions();
    window.addEventListener('resize', setCanvasDimensions);

    class Particle {
      constructor() {
        this.x = Math.random() * canvas.width;
        this.y = Math.random() * canvas.height;
        this.size = Math.random() * 1.8 + 0.4;
        this.speedX = (Math.random() - 0.5) * 0.4;
        this.speedY = (Math.random() - 0.5) * 0.4;
        this.color = '#C9A84C';
        this.alpha = Math.random() * 0.45 + 0.1;
      }

      update() {
        this.x += this.speedX;
        this.y += this.speedY;
        if (this.x > canvas.width)  this.x = 0;
        if (this.x < 0)             this.x = canvas.width;
        if (this.y > canvas.height) this.y = 0;
        if (this.y < 0)             this.y = canvas.height;
      }

      draw() {
        ctx.beginPath();
        ctx.arc(this.x, this.y, this.size, 0, Math.PI * 2);
        ctx.fillStyle = this.color;
        ctx.globalAlpha = this.alpha;
        ctx.fill();
      }
    }

    const initParticles = () => {
      particles = [];
      const count = Math.min(80, Math.floor((canvas.width * canvas.height) / 14000));
      for (let i = 0; i < count; i++) particles.push(new Particle());
    };

    const drawCurves = (time) => {
      ctx.beginPath();
      ctx.moveTo(canvas.width * 0.1, canvas.height * 0.5);
      ctx.bezierCurveTo(
        canvas.width * 0.3, canvas.height * (0.3 + Math.sin(time * 0.001) * 0.1),
        canvas.width * 0.7, canvas.height * (0.6 + Math.cos(time * 0.001) * 0.1),
        canvas.width * 0.9, canvas.height * 0.3
      );
      ctx.strokeStyle = 'rgba(201, 168, 76, 0.18)';
      ctx.lineWidth = 1.5;
      ctx.stroke();

      ctx.beginPath();
      ctx.moveTo(canvas.width * 0.2, canvas.height * 0.7);
      ctx.bezierCurveTo(
        canvas.width * 0.4, canvas.height * (0.2 + Math.cos(time * 0.0015) * 0.1),
        canvas.width * 0.6, canvas.height * (0.8 + Math.sin(time * 0.0015) * 0.1),
        canvas.width * 0.8, canvas.height * 0.4
      );
      ctx.strokeStyle = 'rgba(201, 168, 76, 0.1)';
      ctx.lineWidth = 1;
      ctx.stroke();
    };

    const animate = (time) => {
      ctx.clearRect(0, 0, canvas.width, canvas.height);
      drawCurves(time);
      particles.forEach(p => { p.update(); p.draw(); });

      ctx.globalAlpha = 0.07;
      ctx.strokeStyle = '#C9A84C';
      ctx.lineWidth = 0.5;
      for (let a = 0; a < particles.length; a++) {
        for (let b = a; b < particles.length; b++) {
          const dx = particles[a].x - particles[b].x;
          const dy = particles[a].y - particles[b].y;
          if (Math.sqrt(dx * dx + dy * dy) < 100) {
            ctx.beginPath();
            ctx.moveTo(particles[a].x, particles[a].y);
            ctx.lineTo(particles[b].x, particles[b].y);
            ctx.stroke();
          }
        }
      }
      ctx.globalAlpha = 1;
      animationFrameId = requestAnimationFrame(animate);
    };

    initParticles();
    animationFrameId = requestAnimationFrame(animate);
    window.addEventListener('resize', initParticles);

    return () => {
      cancelAnimationFrame(animationFrameId);
      window.removeEventListener('resize', setCanvasDimensions);
      window.removeEventListener('resize', initParticles);
    };
  }, []);

  return (
    <canvas
      ref={canvasRef}
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        width: '100%',
        height: '100%',
        pointerEvents: 'none',
        zIndex: 0,
        opacity: 0.6,
      }}
    />
  );
}
